import { CircularProgress } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';

interface WeeklyData {
    شنبه: [number, number];
    یکشنبه: [number, number];
    دوشنبه: [number, number];
    'سه شنبه': [number, number];
    چهارشنبه: [number, number];
    پنجشنبه: [number, number];
    جمعه: [number, number];
}

interface Props {
    data: WeeklyData;
}

const WeeklyProgress = ({ data }: Props) => {
    const daysOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'] as const;

    const allDays = daysOfWeek.flatMap((day) => {
        const weekData = data[day];
        return [
            { day, week: 1, percent: weekData[0] },
            { day, week: 2, percent: weekData[1] }
        ];
    });

    return (
        <div>
            <div className='mb-3 grid grid-cols-7 gap-1 border-b border-b-gray-300 pb-2.5'>
                {daysOfWeek.map((day, index) => (
                    <div key={`${day}-${index}`} className='text-center text-xs font-semibold text-gray-600'>
                        {day}
                    </div>
                ))}
            </div>
            <div className='grid grid-cols-7 gap-2'>
                {allDays.map((item, dayIndex) => (
                    <div
                        key={`${item.day}-week${item.week}-${dayIndex}`}
                        className='flex flex-col items-center justify-center space-y-1'
                    >
                        <CircularProgress
                            percentage={item.percent}
                            size={40}
                            barColor={cn({
                                'text-green-500': item.percent >= 70,
                                'text-warning-500': item.percent >= 40 && item.percent < 70,
                                'text-danger-500': item.percent < 40
                            })}
                            strokeWidth={4.5}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WeeklyProgress;

